import type { FaireProductEntity } from "../../entity_types/product";

export const p_9qq89gknbp: FaireProductEntity = {
  token: "p_9qq89gknbp",
  type: "product",
  name: "Cold & Flu Brew - Loose Leaf Herbal Tea",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/e6a8d7b15a08883834c952fbeb87e771a5a5c2393b027575dee6a14c6b5265b4.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    " * Organic and Wild Crafted Herbs \n * Naturally Caffeine Free \n * Promotes A Speedy Recovery And An Enhanced Immune System \n * Loose leaf tea provides 40-60 servings \n\nAt the first sign of a cold or the flu, ease your symptoms with this tasty tea! Rose hips contain the most concentrated form of vitamin c available while elderberries have been well documented to end the flu or cold symptoms days earlier than traditional over the counter medicines that often just mask your symptoms. Lemon balm, ginger and chamomile will all support your system and help you to deal with the symptoms while healing.",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:08.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
